import { createContext, useContext, useSyncExternalStore } from "react";
import type { DraftStore } from "./store.ts";

export const StoreContext = createContext<DraftStore | null>(null);

export function useStore(): DraftStore {
  const s = useContext(StoreContext);
  if (!s) throw new Error("StoreContext fehlt");
  return s;
}

export function useDraft() {
  const s = useStore();
  return useSyncExternalStore(s.subscribe, s.getSnapshot);
}

export function useSyncStatus() {
  const s = useStore();
  return useSyncExternalStore(s.subscribe, s.getStatus);
}
